export const awsTestAudioUrl = 'https://easywebinar-cdn.s3.amazonaws.com/livechat/audio/sample.mp3';
export const leaveAttendeeUrl='https://test-v2.easywebinar.com/v1/easywebinar/v1/attendee/leave'